import { useState } from "react";
import { motion } from "framer-motion";
import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, CITY, SCHEDULE, openWhatsApp } from "@/data/content";

const Contact = () => {
  const [form, setForm] = useState({ nome: "", telefone: "", mensagem: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    const msg = `Olá! Meu nome é ${form.nome || "(não informado)"}.${
      form.telefone ? ` Telefone: ${form.telefone}.` : ""
    } ${form.mensagem || "Gostaria de fazer um pedido."}`;
    openWhatsApp(msg);
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const info = [
    { icon: Phone, label: "Telefone", value: PHONE_DISPLAY, href: `tel:${PHONE_TEL}` },
    { icon: MapPin, label: "Localização", value: `${CITY} - MG e região` },
    { icon: Clock, label: "Atendimento", value: SCHEDULE },
  ];

  return (
    <section id="contato" data-testid="contact-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-4">CONTATO</p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0f1733] tracking-tight leading-tight">
            Peça seu gás <span className="text-[#1d3fd9]">agora mesmo</span>
          </h2>
          <p className="text-slate-500 text-lg mt-5">
            Preencha o formulário e finalize o pedido direto no WhatsApp, ou fale com a gente pelos canais abaixo.
          </p>

          <div className="space-y-4 mt-10">
            {info.map((it) => {
              const Icon = it.icon;
              const content = (
                <div className="flex items-center gap-4">
                  <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#eef1ff]">
                    <Icon className="w-6 h-6 text-[#1d3fd9]" />
                  </span>
                  <div>
                    <p className="text-slate-400 text-sm">{it.label}</p>
                    <p className="text-[#0f1733] font-bold">{it.value}</p>
                  </div>
                </div>
              );
              return it.href ? (
                <a key={it.label} href={it.href} className="block">{content}</a>
              ) : (
                <div key={it.label}>{content}</div>
              );
            })}
          </div>
        </motion.div>

        <motion.form
          data-testid="contact-form"
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="bg-slate-50 rounded-3xl p-8 lg:p-10 shadow-sm"
        >
          <div className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-[#0f1733] mb-2">Nome</label>
              <input
                data-testid="contact-name"
                name="nome"
                value={form.nome}
                onChange={onChange}
                placeholder="Seu nome"
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5 outline-none focus:border-[#1d3fd9] focus:ring-2 focus:ring-[#1d3fd9]/20 transition"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-[#0f1733] mb-2">Telefone</label>
              <input
                data-testid="contact-phone"
                name="telefone"
                value={form.telefone}
                onChange={onChange}
                placeholder="(31) 90000-0000"
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5 outline-none focus:border-[#1d3fd9] focus:ring-2 focus:ring-[#1d3fd9]/20 transition"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-[#0f1733] mb-2">Mensagem</label>
              <textarea
                data-testid="contact-message"
                name="mensagem"
                value={form.mensagem}
                onChange={onChange}
                rows={4}
                placeholder="O que você precisa? Ex: 1 botijão P13 + 1 água 20L"
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5 outline-none focus:border-[#1d3fd9] focus:ring-2 focus:ring-[#1d3fd9]/20 transition resize-none"
              />
            </div>
            <button
              type="submit"
              data-testid="contact-submit"
              className="w-full flex items-center justify-center gap-2 bg-[#a3e635] hover:bg-[#92d420] text-[#0f1733] font-bold py-4 rounded-2xl shadow-lg shadow-[#a3e635]/30 transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-5 h-5" /> Enviar pelo WhatsApp
            </button>
          </div>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;
